import { render, staticRenderFns } from "./ModifyPopup.vue?vue&type=template&id=5cda7f72"
import script from "./ModifyPopup.vue?vue&type=script&lang=js"
export * from "./ModifyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports